<ng-container *ngIf="isVisible()">
  <div [id]="navLink.id" class="ds-grid mx-auto">
    <div class="row">
      <div class="col-12 col-lg-9 mx-auto">
        <h2 class="mt-7 mb-5 d-flex justify-content-center align-items-center ds-heading--l"
            id="benefits-and-features">
          {{'productDetails.technicalInformation' | cxTranslate }}
        </h2>
        <div class="mb-5 d-flex justify-content-center text-center align-items-center ds-body--l"
             id="benefits-and-features">
          {{'productDetails.providedByPublisher' | cxTranslate }}
        </div>
        <ds-accordion [isExpandAllShown]="true" [isFirstItemOpened]="true" borderColor="grey-5">
          <!--  general -->
          <ds-accordion-item
            *ngIf="hasGeneral"
            [header]="'productDetails.general' | cxTranslate"
            accordionId="ngb-panel-general">
            <dcp-classifications-template
              *ngIf="product"
              [parentTechnicalInformationComponent]="true"
              [productClassifications]="productClassifications"
              [product]="product">
            </dcp-classifications-template>
          </ds-accordion-item>
          <!--  deployment, operations, security, compliance, globalization -->
          <ng-container *ngFor="let item of allTechnicalInformationData; let i = index">
            <ds-accordion-item
              *ngIf="hasMethods[i]"
              [header]="translationsHeaders[i] | cxTranslate"
              accordionId="ngb-panel-{{i}}">
              <div *ngFor="let value of item; let h = index">
                <div *ngIf="h < half(item.length)" class="row mx-0">
                  <div class="col-12 col-sm-6 ps-0">
                    <div class="classification-section__item">
                      <ng-container>
                        <div>
                          <div [class.mt-5]="h != 0" class="d-flex ds-color–black special-padding-left">
                            <div class="me-1">
                              <span class="ds-icon--checked me-1 mb-3"></span>
                            </div>
                            <div class="ds-heading--xs">
                              {{value.header}}
                            </div>
                          </div>
                          <div class="ds-body special-padding-left-values">
                            {{value.val}}
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 ps-0">
                    <div class="classification-section__item">
                      <ng-container>
                        <div *ngIf="item[half(item.length) + h]">
                          <div [class.mt-sm-0]="h === 0" class="d-flex ds-color–black mt-5 special-padding-left">
                            <div class="me-1">
                              <span class="ds-icon--checked me-1 mb-3"></span>
                            </div>
                            <div class="ds-heading--xs">
                              {{item[half(item.length) + h].header}}
                            </div>
                          </div>
                          <div class="ds-body special-padding-left-values">
                            {{item[half(item.length) + h].val}}
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </ds-accordion-item>
          </ng-container>
        </ds-accordion>
      </div>
    </div>
  </div>
</ng-container>
<div class="ds-shadow mt-7"></div>
